<app-navbar></app-navbar>
<p-toast ngSkipHydration></p-toast>
@if (isBrowser) {
  <app-cookie-consent
    [(visible)]="isCookieConsentDialogVisible"
    [draggable]="false"
  ></app-cookie-consent>
}

@if (!isViewInitializedSignal()) {
  <div
    class="w-[100dvw] h-[100dvh] fixed top-0 left-0 inset-0 z-[999] pointer-events-none bg-secondary-500 flex flex-col items-center justify-center gap-2">
    <img [src]="logotypeUrl()" alt="logo" class="w-64 h-auto">
    <p-progressSpinner class="w-16 h-16"></p-progressSpinner>
  </div>
}

<div class="relative w-[100vw]">
  <router-outlet></router-outlet>
</div>

@if (googleAnalyticsDebugEnabled()) {
  <app-gtm-debug-panel></app-gtm-debug-panel>
}

<p-button
  class="scroll-nav-btn"
  (onClick)="onScrollButtonClick()"
  [rounded]="true"
  severity="primary"
  [raised]="true"
  styleClass="w-12 h-12 md:w-16 md:h-16"
  icon="pi pi-arrow-right">
</p-button>

@if (isCookieConsentDialogEnabled) {
  <p-button
    class="cookie-consent-btn"
    (onClick)="onCookieConsentHandle()"
    [rounded]="true"
    [raised]="true"
    styleClass="w-12 h-12 md:w-16 md:h-16 bg-secondary-100 ring-2 ring-primary-500 text-primary-500">
    <ng-template pTemplate="icon">
      <ng-icon name="tablerCookie" size="36"></ng-icon>
    </ng-template>
  </p-button>
}

<app-phone-banner></app-phone-banner>
